import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';       // ✅ Importa los estilos Tailwind + Flowbite
import 'flowbite';          // ✅ Importa funcionalidades interactivas de Flowbite
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './components/AuthContext'; // Ajusta la ruta si hace falta

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
